import React, { useState, useEffect, useMemo } from "react";
import { useIsMobile } from "../../helpers/customHooks";
import { useTranslation } from "react-i18next";
import { icons, STRIPE_TEST_KEY } from "../../helpers/constants";
import SubscriptionModal from "../Modals/SubscriptionModal";
import * as request from "../../services/FetchService";
import { useStripe } from "@stripe/react-stripe-js";
import SegmentedControl from "../SegmentedControl/SegmentedControl";
import RadioButton from "../Buttons/RadioButton";
import NewButton from "../Buttons/NewButton";
import DeviceSelectionRowNew from "../Devices/DeviceSelectionRowNew";
import toast from "react-hot-toast";
import AddCardNew from "./Stripe/AddCardNew";
import SearchbarNew from "../Searchbar/SearchbarNew";

const ActivatingNew = ({ cards, priceplans, provider, devices, invoiceInfo, backClicked, setBackClicked, onBackFromStepOne, onBackFromDone, param, setProcessing }) => {
	const { t } = useTranslation();
	const MOBILE = useIsMobile();
	const [showModal, setShowModal] = useState(false);
	const [info, setInfo] = useState("");
	const [thinking, setThinking] = useState(false);
	const [dots, setDots] = useState("");
	const [step, setStep] = useState(1);
	const [selectedPlan, setSelectedPlan] = useState("");
	const [period, setPeriod] = useState(12);
	const [deviceList, setDeviceList] = useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const stripe = useStripe();
	const [finalMessage, setFinalMessage] = useState("");
	const [checkoutPrices, setCheckoutPrices] = useState(null);
	const [loadingPreview, setLoadingPreview] = useState(false);
	const [promoCode, setPromoCode] = useState("");

	useEffect(() => {
		setDeviceList((prev) => {
			const selectedById = new Map((prev || []).map((d) => [d.id, d.selected]));
			return (devices || []).map((d) => ({ ...d, selected: selectedById.get(d.id) ?? false }));
		});
	}, [devices]);

	const leaveFlow = () => {
		setStep(1);
		setInfo("");
		setSelectedPlan("");
		setPeriod(12);
		setDeviceList((prev) => prev.map((d) => ({ ...d, selected: false })));
		setSearchTerm("");
		onBackFromDone();
		setFinalMessage("")
		setProcessing(false);
		setPromoCode("");
	};
	const clearAll = () => {
		setStep(1);
		setInfo("");
		setSelectedPlan("");
		setPeriod(12);
		setDeviceList([]);
		setSearchTerm("");
		setFinalMessage("")
		setProcessing(false);
		setPromoCode("");
	};

	const selectDevice = (deviceId) => {
		setDeviceList((prev) => prev.map((d) => (d.id === deviceId ? { ...d, selected: !d.selected } : d)));
	};

	// const finalizePurchase = () => {
	// 	let obj = {
	// 		duration: period,
	// 		price_plan: selectedPlan,
	// 		quantity: 1,
	// 		devices: getCheckedImeis(),
	// 	};
	// 	request.postUnique("", "payments/dataplan/start", obj).then(async (response) => {
	// 		if (response.data.successful) {
	// 			if (response.data.status === "succeeded") {
	// 				setThinking(false);
	// 				nextStep();
	// 			} else {
	// 				if (!stripe || !response.data.client_secret) {
	// 					setThinking(false);
	// 					setStep(6);
	// 					return;
	// 				}
	// 				const paymentIntent = await stripe.confirmCardPayment(response.data.client_secret);
	// 				if (paymentIntent.paymentIntent.status === "succeeded") {
	// 					setThinking(false);
	// 					nextStep();
	// 				} else {
	// 					setThinking(false);
	// 					setStep(6);
	// 				}
	// 			}
	// 		} else {
	// 			setThinking(false);
	// 			setStep(6);
	// 		}
	// 	});
	// };

	const getCheckedDevices = () => {
		let checkedDevices = deviceList.filter((device) => device.selected);
		return checkedDevices.length;
	};

	const getCheckedImeis = () => {
		let checkedDevices = deviceList.filter((device) => device.selected).map((device) => device.uniqueid);
		return checkedDevices;
	};

	const getSelectedIds = () => {
		let checkedDevices = deviceList.filter((device) => device.selected).map((device) => device.id);
		return checkedDevices;
	};

		const getSelectedDevices = () => {
		let checkedDevices = deviceList.filter((device) => device.selected);
		return checkedDevices;
	};

	const openModal = (variant) => {
		setShowModal(!showModal);
		setInfo(variant);
	};

	const nextStep = (plan = selectedPlan) => {
		setSelectedPlan(plan);
		setStep(step + 1);
		setSearchTerm("")
	};

	const resetStep = (stepValue) => {
		setStep(stepValue);
		setSearchTerm("")
	};

	useEffect(() => {
		if(thinking || step > 3) return;
		if (!backClicked) return;

		if (step === 1) {
			onBackFromStepOne();
			clearAll();
		} else {
			resetStep(step - 1);
		}
		setBackClicked(false);
	}, [backClicked, step]);

	const stepCounter = () => (
		<div className="d-flex flex-row align-items-center justify-content-center">
			<div className={`d-flex flex-column align-items-center ${step < 4 && step > 1 ? "cursor-pointer" : ""}`} onClick={() => step < 4 && resetStep(1)}>
				<div className={`activate-step-counter bold ${step === 1 ? "current" : step > 1 ? "done" : "shadow-inner"}`}>
					<p className="">1</p>
				</div>
				<p className={`bold mt-2 ${step === 1 ? "current" : step > 1 ? "primary" : "dark_grey"}`}>{t("subscription.select_plan")}</p>
			</div>
			<div className="d-flex flex-column align-items-center mx-2">
				<div className={`activate-step-divider mb-4 bold ${step > 1 ? "done" : ""}`} />
			</div>
			<div className={`d-flex flex-column align-items-center ${step > 2 && step < 4 ? "cursor-pointer" : ""}`} onClick={() => (step > 2 && step < 4 ? resetStep(2) : null)}>
				<div className={`activate-step-counter bold ${step === 2 ? "current" : step > 2 ? "done" : "shadow-inner"}`}>
					<p className="">2</p>
				</div>
				<p className={`bold mt-2 ${step === 2 ? "current" : step > 2 ? "primary" : "dark_grey"}`}>{t("subscription.details")}</p>
			</div>
			<div className="d-flex flex-column align-items-center mx-2 ">
				<div className={`activate-step-divider mb-4 bold ${step > 2 ? "done" : ""}`} />
			</div>
			<div className="d-flex flex-column align-items-center">
				<div className={`activate-step-counter bold ${step === 3 ? "current" : step > 3 ? "done" : "shadow-inner dark_grey"}`}>
					<p className="">3</p>
				</div>
				<p className={`bold mt-2 ${step === 3 ? "current" : step > 3 ? "primary" : "dark_grey"}`}>{t("subscription.checkout")}</p>
			</div>
		</div>
	);

	const durationLabel = (duration) => {
		switch (Number(duration)) {
			case 1:
				return t("subscription.monthly");
			case 12:
				return t("subscription.yearly");
			default:
				return t("subscription.duration_months", { count: Number(duration) });
		}
	};

	const paymentLabel = (duration) => {
		switch (Number(duration)) {
			case 1:
				return t("subscription.billed_monthly");
			case 12:
				return t("subscription.billed_yearly");
			default:
				return `${t("subscription.billed_every")} ${t("subscription.duration_months", { count: Number(duration)})}`;
		}
	};

	const activePlan = useMemo(() => {
		if (!Array.isArray(priceplans) || priceplans.length === 0) return null;

		// if you store selectedPlan as plan.name:
		const byName = priceplans.find((p) => p.name === selectedPlan);
		return byName ?? priceplans[0];
	}, [priceplans, selectedPlan]);

	const segmentsNEW = useMemo(() => {
		const prices = activePlan?.prices;
		if (!Array.isArray(prices) || prices.length === 0) return [];

		return [...prices]
			.sort((a, b) => Number(a.duration) - Number(b.duration))
			.map((p) => ({
				label: durationLabel(p.duration),
				value: Number(p.duration),
			}));
	}, [activePlan?.prices, t]);

	useEffect(() => {
		if (segmentsNEW.length === 0) return;

		// keep current if it exists in this plan, otherwise pick first
		const hasCurrent = segmentsNEW.some((s) => s.value === Number(period));
		if (!hasCurrent) setPeriod(segmentsNEW[0].value);
	}, [segmentsNEW]);

	const hasYearlyPrice = useMemo(() => {
		const plan = selectedPlan || activePlan;
		return Array.isArray(plan?.prices) && plan.prices.some((p) => Number(p.duration) === 12);
	}, [selectedPlan, activePlan]);

	const cardPayment = () => {
		return (
			<>
				<h4>{t("subscription.card_payment")}</h4>
				{cards?.length === 0 ? (
					<div className="mt-3">
						<AddCardNew />
					</div>
				) : (
					cards?.map((card, index) => {
						const brand = card?.brand;
						const last4 = card?.last4;
						const month = card?.exp_month;
						const year = card?.exp_year;
						const month_fixed = month < 10 ? `0${month}` : month;
						return (
							<div key={index} className={`d-flex p-3 bg-light-grey mt-3 rounded16 align-items-center justify-content-between ${index < cards?.length - 1 ? "border-settings" : ""}`}>
								<p className="bold">{`**** **** **** ${last4} ${month_fixed}/${year} ${brand.toUpperCase()}`}</p>
								{/* <NewButton notext={true} icon={icons.trashcan} className="rounded8 bg-red me-2 p-3" iconClass={"white-white-icon size_15"} onClick={() => deleteCard(card?.id)} /> */}
							</div>
						);
					})
				)}
			</>
		);
	};

	const invoicePayment = () => {
		return (
			<>
				<h4>{t("subscription.invoice")}</h4>
				<p className="mt-3">{t("subscription.name")}: <span className="bold">{invoiceInfo?.name}</span></p>
				<p className="">{t("subscription.email")}: <span className="bold">{invoiceInfo?.email}</span></p>
				<p className="">{t("subscription.address")}: <span className="bold">{invoiceInfo?.address}</span></p>
				<p className="">{t("subscription.orgnr")}: <span className="bold">{invoiceInfo?.orgn}</span></p>


			</>
		);
	};

	const runPreview = async () => {
		const deviceids = getSelectedIds();
		const dataplan = selectedPlan?.id;
		const duration = period;
		if (deviceids?.length === 0 || !dataplan || !duration) return;

		// const object = {
		// 	duration: period,
		// 	devices: deviceids.map((id) => ({
		// 		deviceid: id,
		// 		dataplan: dataplan,
		// 		...(promoCode ? { promo_code: promoCode } : {})
		// 	}))
		// };


		setLoadingPreview(true)
		//setStep(3); // processing
		//setThinking(true);

		try {
			const preview = await request.postSubscription("", "payments/dataplan/preview/", {
				duration,
				dataplan,
				deviceids,
			}, param);
			if(preview?.data?.successful){
				setCheckoutPrices(preview?.data)
				nextStep()
				setLoadingPreview(false)
				return;
			}else{
				toast.error(t("toast.error"));
				setFinalMessage(preview?.data?.message ?? t("toast.error"))
				setStep(6);
			}
			setLoadingPreview(false)

		}catch(error){
			toast.error(error?.message || t("toast.error"));
			setFinalMessage(error?.message)
			setStep(6);
			setLoadingPreview(false)
		}finally{

		}

	}

	const startSubscription = async () => {
		const deviceids = getSelectedIds();
		const dataplan = selectedPlan?.id;
		const duration = period;
		if (deviceids?.length === 0 || !dataplan || !duration) return;

		setStep(4); // processing
		setThinking(true);
		setProcessing(true)

		try {
			const startResponse = await request.postSubscription("", "payments/dataplan/start/", {
				duration,
				dataplan,
				deviceids,
			}, param);
			const data = startResponse?.data;

			if (!data?.successful) {
				toast.error(data?.message || t("toast.error"));
				setFinalMessage(data?.message)
				setStep(6);
				return;
			}

			if (data?.status === "active") {
				toast.success(t("toast.success"));
				setStep(5);
				return;
			}
			if(data?.status === "failed"){
				toast.error(data.message);
				setFinalMessage(data?.message)
				setStep(6);
				return;
			}

			if (data?.status === "requires_action") {
				if (!stripe || !data?.client_secret) {
					toast.error(t("toast.error"));
					setStep(6);
					return;
				}

				const { error, paymentIntent: confirmed } = await stripe.confirmCardPayment(data.client_secret);

				if (error) {
					toast.error(error.message);
					setFinalMessage(error?.message)
					setStep(6);
					return;
				}

				if (confirmed?.status !== "succeeded" && confirmed?.status !== "processing") {
					toast.error(`Payment status: ${confirmed?.status || "unknown"}`);
					setStep(6);
					setFinalMessage(confirmed?.status)

					return;
				}

				toast.success(t("toast.success"));
				setStep(5);
				return;
			}

				const msg = startResponse?.data?.message
                toast.error(msg ?? t("toast.error"))
			setStep(6);
		} catch (error) {
			toast.error(error?.message || t("toast.error"));
			setFinalMessage(error?.status)
			setStep(6);
		} finally {
			setThinking(false);
		}
	};

	const perMonth = (dur) => {
		switch(dur){
			case 1:
				return t(`subscription.month`, {count: 1}).toLowerCase()
			case 12: 
				return t(`subscription.year`).toLowerCase()
			default: return `"${t(`subscription.month`, {count: dur}).toLowerCase()}"`
		}
	}

	const selectPlanRender = () => {
		return (
			<div className="d-flex flex-column align-items-center">
				{segmentsNEW.length > 1 && (
					<>
						<SegmentedControl segments={segmentsNEW} value={period} callback={(val) => setPeriod(val)} segmentWidth={MOBILE ? "px-5" : "w-50"} className="bg-grey mt-3 mb-1" activeBg="bg-gradient" name="period" />
						<p className="m-0 p-0 mb-3">{t("subscription.save_money")}</p>
					</>
				)}
				<div className={`d-flex flex-column w-100 dataplan-selection mt-3`}>
					{priceplans?.map((plan, index) => (
						<div key={index} className={`bg-white grey-blue ${selectedPlan === plan ? "border-selected" : "border-invis"} p-3 d-flex flex-column position-relative cursor-pointer mb-3 settings-radius`} onClick={() => setSelectedPlan(plan)}>
							<RadioButton selected={selectedPlan === plan} className="position-absolute top-0 end-0 me-3 mt-3" />
							<h3>
								{plan.name}
							</h3>
							<p className="bold">{plan?.subtitle}</p>
							<div className="d-flex">
								{plan?.prices?.map((price, index) => {
									if(period !== price?.duration) return;
									const price_clean = new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(price.price_incvat / 100 / period)
									return (
										<div key={index} className={`d-flex flex-column align-items-end me-3 grey-blue}`}>
											<div className="d-flex">
												<h2>{price_clean}</h2>
												{"\u00A0"}
												<h4 className="align-self-end mb-1">
													{`${price.currency} / ${perMonth(1)}`}
												</h4>
											</div>
										</div>
									);
								})}
							</div>
							<p>{paymentLabel(period)}</p>

							<NewButton textClass={"p"} className={`bg-grey-blue white medium py-2 px-3 rounded24 position-absolute bottom-0 end-0 me-3 mb-3`} 
							onClick={(e) => {
								e.stopPropagation();
								openModal(plan);
							}}>
								{t("subscription.read_more")}
							</NewButton>
						</div>
					))}
					<NewButton className={`bg-gradient ${!selectedPlan ? "disabled" : ""} white-white bold p-3 rounded24`} onClick={() => nextStep(selectedPlan)}>
						{t("subscription.continue")}
					</NewButton>
				</div>
			</div>
		);
	};

	const filterSearch = (searchWord) => {
		setSearchTerm((searchWord ?? "").trim().toLowerCase());
	};

	const filteredDevices = useMemo(() => {
		if (!searchTerm) return deviceList;
		return deviceList.filter((device) => {
			const name = (device?.name ?? "").toLowerCase();
			const imei = (device?.imei ?? "").toLowerCase();
			const uid = (device?.uniqueid ?? "").toLowerCase();
			return name.includes(searchTerm) || imei.includes(searchTerm) || uid.includes(searchTerm);
		});
	}, [deviceList, searchTerm]);
	
	const selectDeviceRender = () => {
		return (
			<div className="d-flex flex-column align-items-center">
				<div className={`d-flex flex-column w-100 dataplan-selection`}>
					<div className="w-50 mt-3">
						<SearchbarNew submitSearch={(data) => filterSearch(data)} />
					</div>
					<p className="bold mt-3 mb-1 align-self-start">{t("subscription.select_devices")}</p>
					<div className={`${!MOBILE ? "geofence_device_list" : ""} scrollable-y rounded24 bg-white py-2`}>
						{filteredDevices.length === 0 &&
							<div className={`p-3 w-100 d-flex flex-column bg-transparent`}>
								<span className="regular">{t("settings.no_devices")}</span>
							</div>
						}
						{filteredDevices.map((device, index) => {
							const limitToast = () => toast(t("subscription.not_admin"), { icon: <img className="size_20 grey-blue-icon" src={icons.info_icon} alt="" />, autoClose: 10000 });
							const can_select = device?.is_admin ?? false;
							return <DeviceSelectionRowNew key={device.id ?? index} index={index} text={device.name} subtitle={device.imei} last={index === filteredDevices?.length - 1} selected={device.selected ? true : false} selectable={can_select} onClick={() => (can_select ? selectDevice(device.id) : limitToast())} />;
						})}
					</div>
					{/* PROMO SECTION */}
					<p className="bold mt-3 mb-1 align-self-start">{t("subscription.add_promo")}</p>
					<div className="">
						<form>
							<div className="form-group d-flex align-items-center">
								<input
									type="text"
									className="form-control rounded24 p-3 bg-white grey-blue"
									id="promo"
									defaultValue={promoCode}
									onChange={(e) => {
										setPromoCode(e.target.value)
									}}

								/>
							</div>
						</form>
					</div>
					<NewButton className={`bg-gradient ${getCheckedDevices() === 0 ? "disabled" : ""} white-white bold p-3 rounded24 mt-3`} onClick={() => runPreview(selectedPlan)}>
						{t("subscription.continue")}
						<span className={`${loadingPreview ? "" : "d-none"} ms-2 size_15 spinner-grow`} />

					</NewButton>
				</div>
			</div>
		);
	};

	const checkoutRender = () => {
		return (
			<div className="d-flex flex-column align-items-center">
				<div className={`d-flex flex-column w-100 dataplan-selection`}>
					<p className="bold mt-3 mb-1 align-self-start">{t("subscription.payment_summary")}</p>
					<div className="d-flex flex-column bg-white settings-radius p-3">
						<div className="d-flex justify-content-around">
							<div className="d-flex flex-column align-items-center">
								<p className="bold dark-grey">{t("subscription.data_plan")}</p>
								<p className="bold grey-blue">{`${selectedPlan?.name} ${durationLabel(period)}`}</p>
							</div>
							<div className="d-flex flex-column align-items-center">
								<p className="bold dark-grey">{t("subscription.devices")}</p>
								<p className="bold grey-blue">{`${getCheckedDevices()} ${t("subscription.devices", { count: getCheckedDevices() })}`}</p>
							</div>
						</div>
						<hr className={`m-0 p-0 mt-3 event-divider bg-light-grey mx-5`} />
						<div className="d-flex justify-content-between justify-content-lg-around mx-5">
							<div className={`d-flex flex-column align-items-start me-3 mt-3`}>
								<p className="align-self-start bold">{t("subscription.total")}:</p>
								<div className="d-flex">
									<h2>{checkoutPrices?.amount_inc_vat / 100}</h2>
									{"\u00A0"}
									<h4 className="align-self-end mb-1">{checkoutPrices?.currency?.toUpperCase()}</h4>
								</div>
								<p className="dark-grey">{paymentLabel(period)}</p>
							</div>
							{provider !== "invoice" && provider !== "stripe" && (
								<div className={`d-flex flex-column align-items-start justify-content-end me-3 mt-3`}>
									<div className="d-flex green">
										<h2>{"XXX"}</h2>
										{"\u00A0"}
										<h4 className="align-self-end mb-1">{"SEK"}</h4>
									</div>
									<p className="dark-grey">{t("subscription.savings")}</p>
								</div>
							)}
						</div>
					</div>
					<p className="bold mt-3 mb-1 align-self-start">{t("subscription.payment_method")}</p>
					<div className="d-flex flex-column bg-white settings-radius p-3">{provider === "invoice" ? invoicePayment() : cardPayment()}</div>
					<NewButton className={`bg-gradient ${cards?.length === 0 && provider !== "invoice" ? "disabled" : ""} white-white bold p-3 rounded24 mt-3`} onClick={() => startSubscription()}>
						{t("subscription.proceed_with_payment")}
					</NewButton>
				</div>
			</div>
		);
	};

	const processingRender = () => {
		return (
			<div className="d-flex flex-column align-items-center mt-3">
				<div className={`d-flex flex-column w-100 dataplan-selection`}>
					<div className="d-flex flex-column bg-white settings-radius p-5">
						<div className="d-flex justify-content-around">
							<h3>{`${t("subscription.processing")}${dots}`}</h3>
						</div>
					</div>
				</div>
			</div>
		);
	};

	const errorRender = () => {
		return (
			<div className="d-flex flex-column align-items-center mt-3">
				<div className={`d-flex flex-column w-100 dataplan-selection`}>
					<div className="d-flex flex-column bg-white settings-radius px-5 py-3">
						<div className="d-flex flex-column justify-content-center">
							<h4>{t("subscription.something_went_wrong")}</h4>
							<p className="mt-3">{finalMessage ?? t("subscription.something_went_wrong")}</p>
						</div>
					</div>
					<NewButton className={`bg-gradient white-white bold p-3 rounded24 mt-3`} onClick={() => leaveFlow()}>
						{t("subscription.go_back")}
					</NewButton>
				</div>
			</div>
		);
	};

	const successRender = () => {
		return (
			<div className="d-flex flex-column align-items-center mt-3">
				<div className={`d-flex flex-column w-100 dataplan-selection`}>
					<div className="d-flex flex-column bg-white settings-radius p-5">
						<div className="d-flex flex-column justify-content-around">
							<h3>{t("subscription.purchase_successful")}</h3>
							<p className="mt-3">{t("subscription.purchase_successful_body")}</p>
						</div>
					</div>
					<NewButton className={`bg-gradient white-white bold p-3 rounded24 mt-3`} onClick={() => leaveFlow()}>
						{t("subscription.go_back")}
					</NewButton>
				</div>
			</div>
		);
	};

	useEffect(() => {
		let intervalId;
		if (thinking) {
			let dotCount = 0;
			intervalId = setInterval(() => {
				dotCount = (dotCount % 3) + 1; // Loop through 1, 2, 3 dots
				setDots(".".repeat(dotCount));
			}, 500);
		}

		return () => {
			clearInterval(intervalId); // Clean up interval
		};
	}, [thinking]);

	const renderSelection = () => {
		switch (step) {
			case 1:
				return selectPlanRender();
			case 2:
				return selectDeviceRender();
			case 3:
				return checkoutRender();
			case 4:
				return processingRender();
			case 5:
				return successRender();
			case 6:
				return errorRender();
			default:
				return errorRender();
		}
	};

	return (
		<>
			{stepCounter()}
			{renderSelection()}
			<SubscriptionModal show={showModal} type={"additional"} info={info} onClose={() => setShowModal(!showModal)} />
		</>
	);
};

export default ActivatingNew;
